<div [hidden]="!PartialViewReady">
    <h2 class="mat-title">
        College Terms Editor<span *ngIf="AdminCollege"> - {{AdminCollege.CollegeName}}</span>
    </h2>
    <div>
        <div>Listed below are all defined term windows for this college. Student access to creating <em>new</em> dual enrollment requests in the DELTA system for a college is limited to when a term window is open. Use the buttons below to create a new term window or edit an existing term window for this college. Note: Any term window for which active student request records exist cannot be edited or removed.</div>
        <div class="buttongroup" fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" *ngIf="ShowingTermEntryPanel !== true">
            <button mat-raised-button color="primary" (click)="ShowTermEntryEditorPanel()">Add New Term Window</button>
        </div>
    </div>
    <div *ngIf="ShowingTermEntryPanel === true" class="mat-elevation-z12 entrypanel" style="margin-bottom:20px">
        <form [formGroup]="TermEntryForm" novalidate fxLayout="column">
            <div fxLayout="row" fxLayout.lt-md="column">
                <mat-form-field style="margin-right:15px">
                    <mat-select formControlName="CollegeSchoolYear" placeholder="Select College Year...">
                        <mat-option *ngFor="let year of AllCollegeYears" [value]="year">{{year | collegeSchoolYear:AdminCollege.CollegeID}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="margin-right:15px">
                    <mat-select formControlName="TermCode" placeholder="Select College Term...">
                        <mat-option *ngFor="let term of CollegeTermChoices" [value]="term.TermCode">{{term.TermCode | collegeTerm}} (Term {{term.TermCode}})</mat-option>
                    </mat-select>
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <mat-form-field style="margin-right:15px">
                        <!-- <j-md-datepicker ng-model="vm.NewTermParams.DateBegin" placeholder="Beginning date" class="advisorsearch"></j-md-datepicker> -->
                        <input matInput formControlName="DateBegin" [matDatepicker]="dpbegin" placeholder="Beginning Date" />
                        <mat-datepicker-toggle matSuffix [for]="dpbegin" [disabled]="false"></mat-datepicker-toggle>
                        <mat-datepicker #dpbegin></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field style="margin-right:15px">
                        <!-- <j-md-datepicker ng-model="vm.NewTermParams.DateEnd" placeholder="Ending date" class="advisorsearch"></j-md-datepicker> -->
                        <input matInput formControlName="DateEnd" [matDatepicker]="dpend" placeholder="Ending Date" />
                        <mat-datepicker-toggle matSuffix [for]="dpend" [disabled]="false"></mat-datepicker-toggle>
                        <mat-datepicker #dpend></mat-datepicker>
                    </mat-form-field>
                </div>
                <mat-form-field style="margin-right:15px" fxHide fxShow-gt-xs>
                    <!-- <j-md-datepicker ng-model="vm.NewTermParams.DateBegin" placeholder="Beginning date" class="advisorsearch"></j-md-datepicker> -->
                    <input matInput formControlName="DateBegin" [matDatepicker]="dpbegin2" placeholder="Beginning Date" />
                    <mat-datepicker-toggle matSuffix [for]="dpbegin2" [disabled]="false"></mat-datepicker-toggle>
                    <mat-datepicker #dpbegin></mat-datepicker>
                </mat-form-field>
                <mat-form-field style="margin-right:15px" fxHide fxShow-gt-xs>
                    <!-- <j-md-datepicker ng-model="vm.NewTermParams.DateEnd" placeholder="Ending date" class="advisorsearch"></j-md-datepicker> -->
                    <input matInput formControlName="DateEnd" [matDatepicker]="dpend2" placeholder="Ending Date" />
                    <mat-datepicker-toggle matSuffix [for]="dpend2" [disabled]="false"></mat-datepicker-toggle>
                    <mat-datepicker #dpend></mat-datepicker>
                </mat-form-field>
            </div>
            <div *ngIf="TermEntryForm.value.TermWindowID != null">
                <em>Note: Existing term windows cannot have their college school year or college term edited. If the year or term is incorrect, please use the "Remove Term Window" button first to remove the entry and then recreate it.</em>
            </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">        
            <button *ngIf="TermEntryForm.value.TermWindowID == null" mat-raised-button color="primary" (click)="AddTermHandler()" [disabled]="TermEntryForm.invalid">Add</button>
            <button *ngIf="TermEntryForm.value.TermWindowID != null" mat-raised-button color="primary" (click)="UpdateTermHandler()" [disabled]="TermEntryForm.$invalid">Update</button>
            <button mat-raised-button color="warn" (click)="AddTermCancelHandler()">Cancel</button>
        </div>
    </div>

    <!-- Terms Table -->
    <mat-table class="bordered" #table [dataSource]="TermsData" matSort matSortActive="DateBegin" matSortDirection="desc">
        <ng-container matColumnDef="CollegeYear">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">College Year</mat-header-cell>
            <mat-cell *matCellDef="let term" class="centered">{{term.CollegeSchoolYear | collegeSchoolYear:AdminCollege.CollegeID}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="TermCode">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Term Code</mat-header-cell>
            <mat-cell *matCellDef="let term" class="centered">{{term.TermCode}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Term">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Term</mat-header-cell>
            <mat-cell *matCellDef="let term" class="centered">{{term.TermCode | collegeTerm}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateBegin">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Beginning Date</mat-header-cell>
            <mat-cell *matCellDef="let term" class="centered"><span *ngIf="term.DateBegin">{{term.DateBegin | datefns:'M/DD/YYYY'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateEnd">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Ending Date</mat-header-cell>
            <mat-cell *matCellDef="let term" class="centered"><span *ngIf="term.DateEnd">{{term.DateEnd | datefns:'M/DD/YYYY'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let term" class="centered">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutWrap>
                    <button mat-raised-button color="primary" (click)="ShowTermEntryEditorPanel(term)" class="buttonpad">Edit Term Window</button>
                    <button mat-raised-button color="warn" (click)="RemoveTerm(term)" [disabled]="term.InUse === true" class="buttonpad">Remove Term Window</button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Term(s)</mat-header-cell>
            <mat-cell *matCellDef="let term">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>College Year</div>
                        <div>{{term.CollegeSchoolYear | collegeSchoolYear:AdminCollege.CollegeID}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Term Code</div>
                        <div>{{term.TermCode}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Term</div>
                        <div>{{term.TermCode | collegeTerm}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Beginning Date</div>
                        <div>{{term.DateBegin | datefns:'M/DD/YYYY'}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Ending Date</div>
                        <div>{{term.DateEnd | datefns:'M/DD/YYYY'}}</div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="ShowTermEntryEditorPanel(term)">Edit Term Window</button>
                        <button mat-raised-button color="warn" (click)="RemoveTerm(term)" [disabled]="term.InUse === true">Remove Term Window</button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let term"><em>No term windows have been set for this college.</em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns;let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>
    <mat-paginator #paginator [length]="TermsData.data.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/manageterms/manageterms.component.html